// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1poZN","box":"WorkspacesBox_box__18GKl","node":"WorkspacesBox_node__1kAtC"};